import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledLeaveAtDoorstep = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			rx: 8,
			fill: "#FEF6EA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5 6H6.5V18H15.5V6Z",
			fill: "white",
			stroke: "#B47F23",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3 13.1C13.7418 13.1 14.1 12.7418 14.1 12.3C14.1 11.8582 13.7418 11.5 13.3 11.5C12.8582 11.5 12.5 11.8582 12.5 12.3C12.5 12.7418 12.8582 13.1 13.3 13.1Z",
			fill: "#B47F23"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7292 15.1878V16.9378C13.7292 18.0377 13.7292 18.5878 14.071 18.9293C14.4128 19.2709 14.9626 19.2712 16.0625 19.2712H16.9375C18.0374 19.2712 18.5875 19.2712 18.929 18.9293C19.2705 18.5875 19.2708 18.0377 19.2708 16.9378V15.1878M14.1287 14.5505L13.7292 15.1878H19.2708L18.9057 14.5791C18.6566 14.1641 18.5323 13.9567 18.3314 13.843C18.131 13.7295 17.8889 13.7295 17.405 13.7295H15.6113C15.1379 13.7295 14.9011 13.7295 14.7033 13.8389C14.5056 13.9485 14.3799 14.1492 14.1287 14.5505ZM16.5 15.1878V13.7295V15.1878ZM15.9167 16.501H17.0833H15.9167Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.2708 15.1878L18.9057 14.5791C18.6566 14.1641 18.5323 13.9567 18.3314 13.843C18.131 13.7295 17.8889 13.7295 17.405 13.7295H15.6113C15.1379 13.7295 14.9011 13.7295 14.7033 13.8389C14.5056 13.9485 14.3799 14.1492 14.1287 14.5505L13.7292 15.1878V16.9378C13.7292 18.0377 13.7292 18.5878 14.071 18.9293C14.4128 19.2709 14.9626 19.2712 16.0625 19.2712H16.9375C18.0374 19.2712 18.5875 19.2712 18.929 18.9293C19.2705 18.5875 19.2708 18.0377 19.2708 16.9378V15.1878ZM13.7292 15.1878H19.2708M16.5 15.1878V13.7295M15.9167 16.501H17.0833",
			stroke: "#B47F23",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledLeaveAtDoorstep);
const Memo = memo(ForwardRef);
export default Memo;
